export enum EntityCategory {
  PRODUCT = 'PRODUCT',
  APP_REGISTRY = 'APP_REGISTRY',
  CUSTOM_APPS = 'CUSTOM_APPS',
  ANALYTICS = 'ANALYTICS',
}

export enum RoutePath {
  ENTITIES = '/entities',
  APP_REGISTRY = '/app-registry',
  APPS = '/apps',
  SETTINGS = '/settings',
  ACCOUNT = '/account',
  ANALYTICS = '/analytics',
}
